
<div class="breadcrumbs">
  <ul class="breadcrumbs__list">
    <li><a href="javascript:;" >General</a></li>
    <li><a href="javascript:;" [routerLink]="['/' + RouterLinks.Documents]" >Documents</a></li>
    <li>Policy documents</li>
  </ul>
</div>
<main class="page-main">
  <div class="layout layout--central">
    <div class="layout__row">
      <app-landing-left-sidebar></app-landing-left-sidebar>
      <div class="layout__bodycol">
        <header class="central-header d-none d-lg-flex">
          <div class="central-header__title">
            <h3>Policy documents</h3>
          </div>
          <div class="central-header__actions">

            <a href="javascript:;" (click)="openSidesheet()" class="central-header__actions-filters {{dataset?.length > 0? '' : 'is-empty'}} d-none d-md-flex" id="filters-trigger" data-sidesheet-trigger="filters">
              <div>Filters</div>
              <span>{{dataset?.length}}</span>
            </a>

          </div>
        </header>

        @for (category of categories; track category) {
          <div class="policy-doc-card-group">
            <!-- personal logo as inline svg -->
            @if (getCategoryPolicies(category?.category_id)?.length > 0) {
              <svg-icon src="assets/{{category?.category_id}}/logo.svg" alt="{{category?.category_name}}"
                class="img-fluid fill-{{getCSS(category?.category_name)}}"
              [applyClass]="true"></svg-icon>
            }
            @for (policy of getCategoryPolicies(category?.category_id); track policy) {
              <ng-caontainer>
                <div class="policy-doc-card policy-doc-card--{{getCSS(category?.category_name)}} is-active">
                  <div class="policy-doc-card__title">
                    <p>{{policy?.policy_id}}/{{policy?.version_id}}</p>
                    <h3>{{policy?.product_name}}</h3>
                  </div>
                  <div class="policy-doc-card__company">
                    <div class="policy-doc-card__company-thumb">
                      <img src="{{policy?.underwriter_logo}}" class="img-fluid">
                    </div>
                    <div class="policy-doc-card__company-rating">
                      <p><small>{{policy?.insurer}}</small></p>
                    </div>
                  </div>
                  <a href="#personal-1" class="policy-doc-card__list-trigger collapsed" data-toggle="collapse"
                    aria-expanded="false">
                    <p>{{policy?.documents?.length}} documents</p>
                    <svg class="icon">
                      <use xlink:href="#dropdown"></use>
                    </svg>
                  </a>
                  <ul class="policy-doc-card__list collapse" id="personal-1">
                    @for (doc of policy?.documents; track doc) {
                      <li class="policy-doc-card__list-item">
                        <a href="javascript:;" (click)="openDocument(doc, policy)">
                          <h6 class="font-16">{{doc?.document_name}}</h6>
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              </ng-caontainer>
            }
          </div>
        }




      </div>
    </div>
  </div>
</main>
<app-disclaimer></app-disclaimer>

<div class="sidesheet " id="filters-sidesheet">
  <div class="sidesheet__inner">
    <div class="sidesheet__header">
      <a href="javascript:;" (click)="closeSidesheet()" class="sidesheet__header-back">
        <svg class="icon">
          <use xlink:href="#arrow-left-small"></use>
        </svg>
      </a>
      <h5>Filters</h5>
    </div>
    <div class="sidesheet__body">

      <h6 class="font-16 mb-20">Insurer</h6>

      <div class="row row--xs">
        @for (insurer of insurers; track insurer) {
          <div class="col-6 col-md-4">
            <label class="custom-input custom-input--radio custom-input--icon-insurer custom-input--icon-insurer-no-indi">
              <input type="checkbox" name="demo-swap-insurer" class="checkbox-insurer" id="{{insurer?.insurer_id}}"  value="{{insurer?.insurer_id}}">
              <span class="custom-input__label">
                <img src="{{insurer?.logo}}" class="img-fluid" alt="The Hollard Insurance Company">
              </span>
              <span class="custom-input__indi"></span>
            </label>
          </div>
        }

      </div>

      <hr class="hr hr--bdr hr--xs-md mt-15">

      <h6 class="font-16 mb-20">Categories</h6>

      <div class="row row--xs">
        @for (category of categories; track category) {
          <div class="col-6 col-md-4">
            <label class="custom-input custom-input--radio custom-input--icon-insurer custom-input--icon-insurer-no-indi">
              <input type="checkbox" name="demo-swap-product" class="checkbox-category" id="{{category?.category_id}}" value="{{category?.category_id}}">
              <span class="custom-input__label">
                <img src="assets/{{category?.category_id}}/logo.svg" class="img-fluid" alt="{{category?.category_name}}">
                <!-- <svg-icon src="assets/{{category?.category_id}}/logo.svg" alt="{{category?.category_name}}"
              class="img-fluid fill-{{getCSS(category?.category_name)}}" [applyClass]="true"></svg-icon> -->
            </span>
            <span class="custom-input__indi"></span>
          </label>
        </div>
      }

    </div>

    <hr class="hr hr--bdr hr--xs-md mt-15">

    <h6 class="font-16 mb-20">Classes</h6>

    <div class="form-group">
      @for (class of classes; track class) {
        <label class="custom-input custom-input--checkbox">
          <input type="checkbox" name="demo-filter-category" class="checkbox-class" id="{{class?.class_id}}" value="{{class?.class_id}}">
          <span class="custom-input__indi"></span>
          <span class="custom-input__label">
            {{class?.class_name}}
          </span>
        </label>
      }
    </div>

  </div>

  <div class="sidesheet__tray">
    <div class="sidesheet__tray-btns">
      <a href="javascript:;" id="filters-reset-btn" (click)="resetFilters()" class="button button--block button--naked">Reset all</a>
      <a href="javascript:;" id="filters-apply-btn" (click)="applyFilters()" class="button button--block button--primary">Apply</a>
    </div>
  </div>
</div>
</div>



